import { ApiClientConfig } from '@aslanpay/portal-common-lib';
import appEnv from 'app/config/appEnv';

const apiConfig: ApiClientConfig = {
  baseURL: appEnv.VITE_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'x-aslan-origin': 'web-app',
  },
};

export default apiConfig;
